import React, { useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import apiUrls from "../../constants/apiUrls";
import { toast } from "react-toastify";
import { customFormDataPost } from "../../helper/api-helper/apiHerlpers";
import apiCommonParams from "../../constants/apiCommonParams";
import "./project.css";
import { useSmarkState } from "../../Context/KeycloakContext";
import AppContext from "../../Context/AppContext";

const Project = (props) => {
  const { applicationId, siteId } = useContext(AppContext);
  const userDetails = useSmarkState();
  const storedToken = localStorage.getItem("keycloakToken");

  const [projectName, setProjectName] = useState("");
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onHideProject = () => {
    if (!isLoading) {
      props.onHideProjectEvent(false);
    }
  };

  const projectNameChangeHandler = (event) => {
    setProjectName(event.target.value);
    setError(false);
  };

  const submitButtonHandler = (event) => {
    event.preventDefault();

    if (!projectName.trim()) {
      setError(true);
      return;
    }

    setIsLoading(true);

    const body = new FormData();
    const data = {
      projectId: 0,
      projectName: projectName,
      applicationId: applicationId,
      siteId: siteId,
      userCreated: apiCommonParams.userCreated,
      userModified: apiCommonParams.userModified,
      createdTime: apiCommonParams.createdTime,
      updatedTime: apiCommonParams.updatedTime
    };

    body.append("project", JSON.stringify(data));
    body.append("swcmTicket", apiCommonParams.swcmTicket);
    body.append("userid", userDetails.userId);

    customFormDataPost(apiUrls.saveProject, body, storedToken)
      .then((result) => {
        if (result.response === "success") {
          props.loadMasterProjectDdl(storedToken);
          toast.success("Project added successfully", {
            position: toast.POSITION.TOP_RIGHT
          });
          props.onHideProjectEvent(false);
        } else {
          toast.warning(result.response, {
            position: toast.POSITION.TOP_RIGHT
          });
        }
      })
      .catch(() => {
        toast.error("Error", {
          position: toast.POSITION.TOP_RIGHT
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Modal show={true} onHide={onHideProject} backdrop="static" keyboard={!isLoading}>
      <Modal.Header closeButton={!isLoading}>
        <Modal.Title>Add New Project</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="form-group">
            <label>Project name</label>
            <input
              type="text"
              value={projectName}
              onChange={projectNameChangeHandler}
              className="form-control required-field"
              placeholder="Project name"
              disabled={isLoading}
            />
            {error && (
              <span className="text-danger">Project name is required</span>
            )}
          </div>
        </form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="primary"
          type="submit"
          onClick={submitButtonHandler}
          disabled={isLoading}
        >
          {isLoading ? "Saving..." : "Submit"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Project;
